import { render, staticRenderFns } from "./RemoveIcon.vue?vue&type=template&id=2d205836&scoped=true&functional=true&"
import script from "./RemoveIcon.vue?vue&type=script&lang=js&"
export * from "./RemoveIcon.vue?vue&type=script&lang=js&"
import style0 from "./RemoveIcon.vue?vue&type=style&index=0&id=2d205836&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "2d205836",
  null
  
)

export default component.exports